<div class="flex flex-column align-items-center">
  <span class="title3Font mb-2">{{dialogData.title}}</span>
  <span class="mb-5">{{dialogData.message}}</span>

  <div class="flex align-items-center justify-content-center w-full">
    <p-button [loading]="requestInProcess"
              (onClick)="sendStandardNotification()"
              label="Standard notification"
              i18n-label
              styleClass="p-button-outlined"
              class="mr-5">
    </p-button>
    <p-button (onClick)="sendCustomNotification()"
              [loading]="requestInProcess"
              label="Custom notification"
              i18n-label
              styleClass="p-button-outlined"
              class="mr-5">
    </p-button>
    <p-button (onClick)="doNotNotify()"
              [loading]="requestInProcess"
              label="Without notifying"
              styleClass="p-button-outlined"
              i18n-label>
    </p-button>
  </div>
</div>